import { subscribeToNewsletter } from '../services/newsletter.service';

const NEWSLETTER_SUBSCRIPTION_CONFIRMED = 'NEWSLETTER_SUBSCRIPTION_CONFIRMED';

const events = [NEWSLETTER_SUBSCRIPTION_CONFIRMED];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(
    NEWSLETTER_SUBSCRIPTION_CONFIRMED,
    ({ submitUrl, payload, csrfToken}) => {
      const onError = (err) => console.warn(err);
      subscribeToNewsletter({
        submitUrl,
        payload,
        csrfToken,
        onError,
      });
    }
  );

};

export const NEWSLETTER_SUBSCRIPTION_EVENTS = {
  NEWSLETTER_SUBSCRIPTION_CONFIRMED,
  initializeEventListeners,
};
